import { render } from "./today-data.vue?vue&type=template&id=22a50002&scoped=true"
import script from "./today-data.vue?vue&type=script&lang=js"
export * from "./today-data.vue?vue&type=script&lang=js"

import "./today-data.vue?vue&type=style&index=0&id=22a50002&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a50002"]])

export default __exports__